import React, { useState, useEffect } from 'react';
import styles from './CustomizedToast.module.scss';
import errorToast from 'assets/icons/vector/error-toast.svg';
import successToast from 'assets/icons/vector/success-toast.svg';
import updateToast from 'assets/icons/vector/update-toast.svg';
import closeToast from 'assets/icons/vector/close-toast.svg';

const toastTypeMap = {
  update: {
    icon: updateToast,
    borderClass: styles['update-border'],
  },
  add: {
    icon: successToast,
    borderClass: styles['success-border'],
  },
  error: {
    icon: errorToast,
    borderClass: styles['error-border'],
  },
};

const CustomizedToast = ({ text, toastType = 'error', close }) => {
  const [exiting, setExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => handleClose(), 3000);
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setExiting(true);
    setTimeout(() => {
      close();
    }, 300);
  };

  const { icon, borderClass } = toastTypeMap[toastType] || toastTypeMap.error;

  return (
    <div className={styles['modal-container']}>
      <div
        className={`${styles['modal-innerContainer']} ${borderClass} ${
          exiting ? styles['exit'] : ''
        }`}
      >
        <div className={styles['title-container']}>
          <img src={icon} alt={toastType} />
          <p className={styles['toast-title']}>{text}</p>
        </div>
        <div className={styles['toast-exit']}>
          <img
            src={closeToast}
            alt="close"
            className={styles['close-icon']}
            onClick={handleClose}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomizedToast;
